/**
 * @description Table of contents - Brent's modified version for article template.
 * @since 2.18.0
 */
const JumpNavArticle = function() {
  const navController = document.querySelector(
    '[data-table-of-contentsarticle-controller]'
  )
  const navContainer = document.querySelector(
    '[data-table-of-contentsarticle-container]'
  )

  if (!navContainer) return
  const linksWrapper = navContainer.querySelector(
    '[data-table-of-contentsarticle-links]'
  )
  const navOverlay = navContainer.querySelector(
    '.table-of-contents-mobile__overlay'
  )

  if (!linksWrapper) return
  const links = linksWrapper.querySelectorAll('ul li')

  if (!navController) return
  const openButton = navController.querySelector('.button')
  const closeButton = linksWrapper.querySelector(
    '.table-of-contents-mobile__header .button'
  )
  const prevNextButtons = navContainer.querySelectorAll(
    '[data-table-of-contentsarticle-mobile-prev-next] button'
  )
  const categorySections = document.querySelectorAll(
    '[data-table-of-contents-category]'
  )

  /**
   * @method stickyNav
   * @description Callback for intersection observer
   */
  const stickyNav = function(entries) {
    entries.forEach(function(entry) {
      // we've passed the element and the intersection
      if (!entry.isIntersecting && window.scrollY >= navController.offsetTop) {
        navController.firstElementChild.classList.add('--is-sticky')
      }
      // we either haven't passed the intersection or are above the element
      else {
        navController.firstElementChild.classList.remove('--is-sticky')
      }
    })
  }

  /**
   * @method isStickyNavController
   * @description create intersection observer
   * @callback stickyNav
   */
  const isStickyNavController = function() {
    const options = {
      root: null,
      threshold: 0
    }

    const observer = new IntersectionObserver(stickyNav, options)
    observer.observe(navController)
  }

  const openJumpNav = function(container) {
    container.classList.remove('+display-none')
    container.classList.add('--is-active')
  }

  const closeJumpNav = function(container) {
    container.classList.remove('--is-active')
    container.classList.add('+display-none')
  }

  const getActiveLink = function() {
    let activeLink = ''
    links.forEach(function(link) {
      if (link.classList.contains('--is-active')) {
        activeLink = link
      }
    })
    return activeLink
  }

  const nextLink = function() {
    let activeLink = getActiveLink()
    activeLink.classList.remove('--is-active')
    activeLink.nextElementSibling.classList.add('--is-active')
    scrollLinkInList(activeLink.nextElementSibling)
    activeLink.nextElementSibling.click()
  }

  const prevLink = function() {
    let activeLink = getActiveLink()
    activeLink.classList.remove('--is-active')
    activeLink.previousElementSibling.classList.add('--is-active')
    scrollLinkInList(activeLink.previousElementSibling)
    activeLink.previousElementSibling.click()
  }

  const setDisabledButton = function() {
    if (links[0].classList.contains('--is-active')) {
      prevNextButtons[0].setAttribute('disabled', true)
      prevNextButtons[0].classList.add('--is-disabled')
    } else {
      prevNextButtons[0].removeAttribute('disabled')
      prevNextButtons[0].classList.remove('--is-disabled')
    }
    if (links[links.length - 1].classList.contains('--is-active')) {
      prevNextButtons[1].setAttribute('disabled', true)
      prevNextButtons[1].classList.add('--is-disabled')
    } else {
      prevNextButtons[1].removeAttribute('disabled')
      prevNextButtons[1].classList.remove('--is-disabled')
    }
  }

  const scrollLinkInList = function(link) {
    return (link.parentElement.scrollTop =
      link.offsetTop - link.offsetHeight * 3)
  }

  const setLinkState = function(entry) {
    let isInList = !!navContainer.querySelector(
      `[data-tocarticle-scroll-to="${entry.target.id}"]`
    )
    if (!isInList) return

    let formattedLinks = Array.prototype.slice.call(links)

    let activeLinksFilter = formattedLinks.filter(elm => {
      return elm.dataset.tocarticleScrollTo !== entry.target.id
    })

    activeLinksFilter.forEach(link => {
      link.classList.remove('--is-active')
    })

    links.forEach(function(link) {
      if (link.dataset.tocarticleScrollTo === entry.target.id) {
        link.classList.add('--is-active')
        scrollLinkInList(link)
      }
    })

    setDisabledButton()
  }

  const removeActiveLinks = entry => {
    let activeClass = '--is-active'
    let desktopController = document.querySelector(
      '[data-table-of-contentsarticle-desktop-controller]'
    )

    if (!desktopController) return false

    let desktopLinks = desktopController.querySelectorAll('li')

    if (!desktopLinks) return false
    desktopLinks = Array.prototype.slice.call(desktopLinks)
    let isInList = !!desktopController.querySelector(
      `[data-tocarticle-scroll-to="${entry.target.id}"]`
    )

    if (!isInList) return

    let activeLinksFilter = desktopLinks.filter(elm => {
      let currentLink = elm.querySelector(
        `[data-tocarticle-scroll-to="${entry.target.id}"]`
      )
      if (currentLink == null) return true

      return currentLink.dataset.tocarticleScrollTo !== entry.target.id
    })

    activeLinksFilter.forEach(link => {
      link.classList.remove(activeClass)
      link.firstElementChild.classList.remove(activeClass)
    })
  }

  const activeSection = function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        removeActiveLinks(entry)
        setLinkState(entry)
      }

      // Desktop
      let activeClass = '--is-active'
      let desktopController = document.querySelector(
        '[data-table-of-contentsarticle-desktop-controller]'
      )

      if (!desktopController) return false

      let desktopLinkContainer = desktopController.querySelector('ul')

      if (
        window.matchMedia('(min-width: 999px)') &&
        entry.target.dataset.hasOwnProperty('tableOfContentsCategory')
      ) {
        let category = entry.target.id
        let currentLink = desktopLinkContainer.querySelector(
          `[data-tocarticle-scroll-to="${category}"]`
        )
        let currentLinkParent = currentLink ? currentLink.parentElement : null

        if (entry.isIntersecting) {
          if (currentLink && !currentLink.classList.contains(activeClass)) {
            currentLink.classList.add(activeClass)
            currentLinkParent.classList.add(activeClass)
          }
        }
      }
    })
  }

  const isActiveSection = function() {
    const options = {
      threshold: 0,
      rootMargin: '0px 0px -75%'
    }

    categorySections.forEach(function(category) {
      let currentLink = document.querySelector(
        `[data-tocarticle-scroll-to="${category.id}"]`
      )

      // Only add IO to sections that have a link to scroll to
      if (currentLink) {
        const observer = new IntersectionObserver(activeSection, options)
        observer.observe(category)
      }
    })
  }

  openButton.addEventListener(
    'click',
    function() {
      setDisabledButton()
      if (navContainer.classList.contains('+display-none')) {
        openJumpNav(navContainer)
      } else {
        closeJumpNav(navContainer)
      }
    },
    { passive: true }
  )

  closeButton.addEventListener(
    'click',
    function() {
      closeJumpNav(navContainer)
    },
    { passive: true }
  )

  navOverlay.addEventListener(
    'touchend',
    function() {
      setTimeout(() => {
        closeJumpNav(navContainer)
      }, 50)
    },
    { passive: true }
  )

  links.forEach(function(link) {
    link.addEventListener(
      'click',
      function() {
        closeJumpNav(navContainer)
      },
      { passive: true }
    )
  })

  prevNextButtons.forEach(function(button) {
    if (button.classList.contains('prev')) {
      button.addEventListener(
        'click',
        function() {
          prevLink()
          setDisabledButton()
        },
        { passive: true }
      )
    } else {
      button.addEventListener(
        'click',
        function() {
          nextLink()
          setDisabledButton()
        },
        { passive: true }
      )
    }
  })

  // Intersection Observer for Sticky Nav
  isStickyNavController()
  isActiveSection()
}

const bindScrollEventsArticle = selector => {
  const elements = document.body.querySelectorAll(selector)
  if (elements.length > 0) {
    elements.forEach(element => {
      createScrollEventsArticle(element)
    })
  }
}

const createScrollEventsArticle = element => {
  const buttons = element.querySelectorAll('[data-tocarticle-scroll-to]')

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      document.activeElement.blur() // Remove the native selection so scrolling looks normal
      e.preventDefault()

      const destinationSelector = `#${button.getAttribute(
        'data-tocarticle-scroll-to'
      )}`
      const jumpNav = document.body.querySelector(
        '[data-table-of-contentsarticle-controller]'
      )
      const jumpNavHeight = jumpNav ? jumpNav.offsetHeight + 10 : '0'
      const destination = document.body.querySelector(`${destinationSelector}`)
      let destinationHeader = destination

      button.classList.add('--is-active')
      button.parentElement.classList.add('--is-active')

      let scrollOptions = {
        behavior: 'auto',
        top:
          window.scrollY +
          destination.getBoundingClientRect().top -
          jumpNavHeight -
          20,
        left: 0
      }

      window.scrollTo(scrollOptions)
      destinationHeader.focus({ preventScroll: true })
      history.replaceState(null, null, `${destinationSelector}`)
    })
  })
}

JumpNavArticle()
bindScrollEventsArticle('.list-nav[data-scroll-to-navigationarticle]')
